import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import PostLoginFooter from '../PostLoginFooter/PostLoginFooter';

interface MainLayoutProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, title, subtitle }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar drawer automatically when navigating between pages on mobile
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen((prev) => !prev);
  };

  return (
    <div className="flex min-h-screen bg-background-subtle">
      {/* Responsive Sidebar */}
      <Header
        variant="sidebar"
        mobileSidebarOpen={mobileSidebarOpen}
        onToggleMobileSidebar={toggleMobileSidebar}
      />

      {/* Main Content Wrapper */}
      <div className="flex-1 flex flex-col ml-0 lg:ml-[210px] min-h-screen transition-all duration-300">
        {/* TopBar with Hamburger Toggle */}
        <Header
          variant="topbar"
          title={title}
          subtitle={subtitle}
          onToggleMobileSidebar={toggleMobileSidebar}
        />

        {/* Page Content */}
        <main className="flex-1 px-3 sm:px-4 pt-2 pb-1">
          {children || <Outlet />}
        </main>

        {/* Post-login Footer */}
        <PostLoginFooter />
      </div>
    </div>
  );
};

export default MainLayout;


